import { Link as LinkS } from "react-scroll";
import styled from "styled-components";
import { COLORS } from "../../../const/colors";

export const FooterMain = styled.footer`
  background: linear-gradient(
    135deg,
    ${COLORS.DARK_BLUE} 0%,
    ${COLORS.BLACK} 100%
  );
  position: relative;
  overflow: hidden;
  z-index: 1;

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background: radial-gradient(
      circle,
      ${COLORS.ORANGE_20} 0%,
      ${COLORS.ORANGE_10} 50%,
      transparent 70%
    );
    z-index: 0;
  }

  &::before {
    top: -100px;
    left: -100px;
  }

  &::after {
    bottom: -100px;
    right: -100px;
  }
`;

export const FooterContainer = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 3rem 1.5rem 9rem;
  position: relative;
  z-index: 1;

  @media screen and (min-width: 992px) {
    padding: 4rem 1.5rem 9rem;
  }

  @media screen and (max-width: 768px) {
    padding-bottom: 10rem;
  }
`;

export const FooterTitle = styled.h1`
  color: ${COLORS.WHITE};
  text-align: center;
  margin-top: 2rem;
  font-size: 1.2rem;
  font-weight: 500;
`;

export const FooterList = styled.ul`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 2rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  row-gap: 1rem;

  img {
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.1);
      box-shadow: 0 0 15px ${COLORS.ORANGE_30};
    }
  }
`;

export const FooterLink = styled(LinkS)`
  color: ${COLORS.LIGHT_GRAY};
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  position: relative;
  transition: all 0.3s ease;
  padding: 0.3rem 0.8rem;
  border-radius: 0.5rem;

  &::after {
    content: "";
    position: absolute;
    width: 0;
    height: 2px;
    bottom: -2px;
    left: 50%;
    background-color: ${COLORS.ORANGE};
    transition: all 0.3s ease;
    transform: translateX(-50%);
  }

  &:hover {
    color: ${COLORS.ORANGE};
    background-color: ${COLORS.WHITE_10};

    &::after {
      width: 80%;
    }
  }
`;

export const FooterSocial = styled.ul`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 1.5rem;
  flex-wrap: wrap;
  row-gap: 1rem;

  .text-xl {
    color: ${COLORS.WHITE};
    font-weight: 500;
    margin-right: 0.5rem;
  }
`;

export const FooterSocialLink = styled.a`
  background-color: ${COLORS.ORANGE};
  color: ${COLORS.WHITE};
  padding: 0.5rem;
  border-radius: 0.5rem;
  font-size: 1.25rem;
  display: inline-flex;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px ${COLORS.BLACK_30};

  &:hover {
    background-color: ${COLORS.DARK_BLUE};
    color: ${COLORS.WHITE};
    transform: translateY(-5px);
    box-shadow: 0 6px 12px ${COLORS.BLACK_50};
  }

  @media screen and (min-width: 992px) {
    font-size: 1.5rem;
    padding: 0.5rem;
  }
`;

export const FooterCopy = styled.span`
  display: block;
  margin-top: 2rem;
  color: ${COLORS.LIGHT_GRAY};
  text-align: center;
  font-size: 0.875rem;
  font-weight: 400;
  padding-bottom: 1rem;

  @media screen and (min-width: 992px) {
    font-size: 1rem;
  }
`;
